import dateTimeHelper from '../Helpers/datetimeHelper';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import JsxHelper from '../Helpers/JsxHelper';
import moneyHelper from '../Helpers/moneyHelper';
import PricingListItem from './PricingListItem';
import stringHelper from '../Helpers/stringHelper';

class PricingServiceOwningOfficeItem extends PricingListItem {
  static FieldsToShowInDataTable() {
    return [
      {
        label: PricingListItem.getSelectedCellHeader,
        orderById: '',
        data: PricingListItem.getSelectedCellContent,
        minWidth: 20,
        tableminWidth: '20px',
      },
      {
        label: 'Pricing Id',
        orderById: 'PricingId',
        data: (item) => PricingListItem.GetPricingIdNavigationCellContent(item),
        type: FieldTypesEnum.Navigation,
      },
      { label: 'FW Office', orderById: 'OfficeName', data: 'OfficeName' },
      { label: 'Country Name', orderById: 'CountryName', data: 'CountryName' },
      {
        label: 'Client Fee',
        orderById: 'OpportunityClientFeeTotal',
        data: (item) => moneyHelper.toMoneyFormat(item.OpportunityClientFeeTotal, item.OpportunityCurrencyCode),
      },
      {
        label: 'Mark-up',
        orderById: 'ClientFeeMarkup',
        data: (item) => `${stringHelper.removeTrailingZeros(item.ClientFeeMarkup)} %`,
      },
      {
        label: '% Revenue',
        orderById: 'NetRevenuePct',
        data: (item) => `${stringHelper.removeTrailingZeros(item.NetRevenuePct)} %`,
      },
      { label: '# Evals', orderById: 'NumEvalsTotal', data: 'NumEvalsTotal' },
      { label: 'Status', orderById: 'Status', data: 'Status' },
      { label: 'Assigned To', orderById: 'AssignedToName', data: 'AssignedToName' },
      {
        label: 'Modified On',
        orderById: 'ModifiedOn',
        data: (item) => dateTimeHelper.toYYYYsMMsDDWithIndefiniteIcon(item.ModifiedOn),
      },
      { label: 'Comments?', orderById: 'HasUserComments', data: (item) => JsxHelper.YesNo(item.HasUserComments) },
    ];
  }
}

export default PricingServiceOwningOfficeItem;
